import React from 'react';
import { Box, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';


const useStyles = makeStyles((theme) => ({
    section: {
        height: '100vh',
        padding: '4em',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    title: {
        marginBottom: '0.5em'
    },
    item: {}
}));

const ProductItemViewMobile = ({ title, items, image, centered, withGap }) => {

    const classes = useStyles();
    const theme = useTheme();

    const matchesXS = useMediaQuery(theme.breakpoints.up('xs'));
    const matchesSM = useMediaQuery(theme.breakpoints.up('sm'));
    const matchesMD = useMediaQuery(theme.breakpoints.up('md'));
    const matchesLG = useMediaQuery(theme.breakpoints.up('lg'));
    const matchesXL = useMediaQuery(theme.breakpoints.up('xl'));

    const titleVariant = matchesXL ? 'h1' : matchesLG ? 'h2' : matchesMD ? 'h3' : matchesSM ? 'h4' : matchesXS ? 'h5' : 'h6';
    const textVariant = matchesXL ? 'h3' : matchesLG ? 'h4' : matchesMD ? 'h5' : matchesSM ? 'h6' : matchesXS ? 'body1' : 'body1';


    return (
        <div className={classes.section} style={{ backgroundImage: `url(${image})` }}>

            <div className={classes.container}>

                {
                    withGap &&
                    <div style={{ height: '20em' }}></div>
                }

                {
                    !withGap &&
                    <div style={{ height: '5em' }}></div>
                }

                <div className={classes.title}>
                    <Typography variant={titleVariant} >
                        <Box fontWeight={900} color={theme.palette.arenco.darkBlue} align="center">
                            {title}
                        </Box>
                    </Typography>
                </div>
                {
                    items?.map(item =>
                        <div className={classes.item}>
                            <Typography variant={textVariant} >
                                <Box fontWeight={500} lineHeight={1.5} color={theme.palette.arenco.darkBlue} align="center">
                                    - {item}
                                </Box>
                            </Typography>
                        </div>)
                }

            </div>
        </div>
    );
};

export default ProductItemViewMobile;